import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class RibbonsTask extends AbstractRequestTask {
  constructor(service = "", user, params, headers) {
    super();
    this._config = getAppConfig();
    this._service = service;
    this._user = user;
    this.method = params.method;
    this._params = params.payload;
    this._headers = headers;

    this.cm_access_token = null;
    if(this._headers && this._headers.cm_access_token) {
      this.cm_access_token = this._headers.cm_access_token;
      delete this._headers.cm_access_token;
    }

  }

  getMethod() {
    if (this.method) return this.method;
    return "GET";
  }

  getEncType() {
    if (this.getMethod() === "POST") return "multipart/form-data";

    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    if (
      data.errors &&
      !data.ribbons &&
      !data.albumDetail &&
      !data.playlistDetail
    ) {
      return false;
    }
    return true;
  }

  getUrl() {
    const config = getAppConfig();
    const service = `${config.end_point_music}/middleware/cms/${this._service}`;
    return service;
  }

  getParams() {
    const params = super.getParams();
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = '1.0.0';
    if(this.cm_access_token) {
      params.cm_access_token = this.cm_access_token;
    }

    return { ...params, ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default RibbonsTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/RibbonsTask.js